export default __webpack_public_path__ + "static/media/O-093.03824f77.png";